import { ADD_CHEF_ALERT_COUNT } from "../actions/types";

const initialState = { items: [] };
export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_CHEF_ALERT_COUNT:
      return {
        items: action.payload.alertChefData,
      };

    default:
      return state;
  }
}
